module.exports = __webpack_public_path__ + "img/10.5b2f5fe7.svg";